import { render, staticRenderFns } from "./AllMaterialsJournalsPage.vue?vue&type=template&id=bbea595e&scoped=true"
import script from "./AllMaterialsJournalsPage.vue?vue&type=script&lang=js"
export * from "./AllMaterialsJournalsPage.vue?vue&type=script&lang=js"
import style0 from "./AllMaterialsJournalsPage.vue?vue&type=style&index=0&id=bbea595e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbea595e",
  null
  
)

export default component.exports